const vcfLinks = {
  details: ({ namespace, groupId }: { namespace: string; groupId: string }) =>
    `/vcf/${namespace}/${groupId}`,

  overview: ({ namespace, groupId }: { namespace: string; groupId: string }) =>
    `/vcf/${namespace}/${groupId}/overview`,

  sharing: ({ namespace, groupId }: { namespace: string; groupId: string }) =>
    `/vcf/${namespace}/${groupId}/sharing`,

  settings: ({ namespace, groupId }: { namespace: string; groupId: string }) =>
    `/vcf/${namespace}/${groupId}/settings`,

  contents: ({ namespace, groupId }: { namespace: string; groupId: string }) =>
    `/vcf/${namespace}/${groupId}/contents`,

  metadata: ({ namespace, groupId }: { namespace: string; groupId: string }) =>
    `/vcf/${namespace}/${groupId}/metadata`,

  activity: ({ namespace, groupId }: { namespace: string; groupId: string }) =>
    `/vcf/${namespace}/${groupId}/activity`,
};

export default vcfLinks;
